import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { loaderInterceptor } from './core';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { AuthService } from './auth/services';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
    provideHttpClient(
      withInterceptors([loaderInterceptor, authInterceptor])
    ),
    
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.initAuth();
    }),
    provideAnimations()
  ]
};
